import React from "react";

function ProductBoostIcon() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 12C0 5.37258 5.37258 0 12 0H16C22.6274 0 28 5.37258 28 12V16C28 22.6274 22.6274 28 16 28H12C5.37258 28 0 22.6274 0 16V12Z"
        fill="#EAECF0"
      />
      <path
        d="M17.5332 9.77734H22.5332V14.7773"
        stroke="#424242"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.5334 9.77734L15.45 16.8607L11.2834 12.694L5.8667 18.1107"
        stroke="#424242"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default ProductBoostIcon;
